export default __webpack_public_path__ + "static/snowboard-c38b66e36a18284768b19b4b08f56c83.png";